{
  
  
  "refinance": "Refinanciamiento",
  "construction": "Construcción",
  
  "standard": "Estándar",
  "custom": "Personalizado",
  
  "buyer": "Comprador",
  "seller": "Vendedor",
  "lender": "Prestamista",
  "borrower": "Prestatario",
  "attorney": "Abogado",
  "title_agent": "Agente de Título",
  "payee": "Beneficiario",
  
  "mortgage": "Hipoteca",
  "disclosure": "Divulgación",
  "survey": "Levantamiento",
  
  "loan_amount": "Monto del Préstamo",
  "down_payment": "Pago Inicial",
  "earnest_money": "Depósito de Garantía",
  "commission": "Comisión",
  
  "active": "Activo",
  "pending": "Pendiente",
  "on_hold": "En Espera",
  
  "wire": "Transferencia Bancaria",
  "check": "Cheque",
  "cash": "Efectivo"
}
